module.exports = __webpack_public_path__ + "img/fabric-texture.ac1839b0.png";